// extracted by mini-css-extract-plugin
module.exports =  {"root":"_93444fe79c--root--dzlQJ","link":"_93444fe79c--link--vMbdm","label":"_93444fe79c--label--g9N7M","info":"_93444fe79c--info--ESXJs"};